<template>
  <div class="event-child" v-if="typeof content !== 'undefined'">
    <div class="event-content" v-html="content" v-if="typeof content === 'string'"></div>
    <Content class="event-content" :content="content" v-else-if="content.length > 0"></Content>
  </div>
</template>

<script>
import Content from '@/components/Utils/Content.vue'

export default {
  name: 'EventSection',

  components: { Content },

  computed: {
    event () {
      return this.$store.getters.event
    },

    content () {
      let content = ''

      switch (this.$route.name) {
        case 'event-invite':
          content = this.event.invite
          break

        case 'event-agenda':
          content = this.event.content_alt && this.event.content_alt.content
            ? this.event.content_alt.content : this.event.content.rendered
          break

        case 'event-proposals':
          content = this.event.proposals
          break

        case 'event-nominations':
          content = this.event.nominations
          break
      }

      return content
    }
  }
}
</script>
